import { render } from "./FilePreview.vue?vue&type=template&id=3e6f4bad&scoped=true"
import script from "./FilePreview.vue?vue&type=script&lang=js"
export * from "./FilePreview.vue?vue&type=script&lang=js"

import "./FilePreview.vue?vue&type=style&index=0&id=3e6f4bad&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6f4bad"]])

export default __exports__